import { get } from 'aws-amplify/api';
const API_BASE_URL = 'billivoRegister';

const getAuthHeaders = async () => {
  return {
    'x-api-key': process.env.REACT_APP_API_GATEWAY_KEY as string,
    'Content-Type': 'application/json',
  };
};

export const getSubscriptionPlans = async () => {
  try {
    const headers = await getAuthHeaders();

    // First call to userHandler
    const subscriptionPlansResponse = await get({
      apiName: `${API_BASE_URL}`,
      path: '/subscriptionPlans',
      options: {
        headers,
      },
    });

    // Check for error in userHandler response
    const subscriptionPlansResponseBody = await (await subscriptionPlansResponse.response).body;
    const subscriptionsBody = (await subscriptionPlansResponseBody.json()) as {
      plans: {
        planName: string;
        description: string;
        pricePerMonth: number;
        pricePerYear: number;
        expenseSubUsers?: number | null;
      }[];
    };
    return subscriptionsBody.plans ?? [];
  } catch (error) {
    console.error('Error creating checkout session:', error);
    throw error;
  }
};
